<template>
  <div class="suduzyz">
    <details>
      <summary>分类列表</summary>
      <Category :list="categories" @search="handleSearch"></Category>
    </details>
    <h1>SUDUZYZ</h1>
    <Info :keyword="keyword || '全部'" :category="category || '全部'" :page="page" :totalPage="totalPage"></Info>
    <Searcher @search="handleSearch" :showCategory="true"></Searcher>
    <Pager :page="page" :totalPage="totalPage" @changePage="handleChangePage"></Pager>
    <Zyzbody :docs="docs" :imgUrl="imgUrl" :token="token"></Zyzbody>
    <Searcher @search="handleSearch" :showCategory="true"></Searcher>
    <Pager :page="page" :totalPage="totalPage" @changePage="handleChangePage"></Pager>
    <Info :keyword="keyword || '全部'" :category="category || '全部'" :page="page" :totalPage="totalPage"></Info>
  </div>
</template>

<script>
import $ from "jquery/dist/jquery.min.js";
import Category from "./Category";
import Info from "./Info";
import Searcher from "./Searcher";
import Pager from "./Pager";
import Zyzbody from "./Zyzbody";
export default {
  name: "Suduzyz",
  props: {
    urlBase: String,
    token: String
  },
  components: {
    Category,
    Info,
    Searcher,
    Pager,
    Zyzbody
  },
  data: function() {
    return {
      count: 0,
      keyword: "",
      category:"",
      page: 1,
      countPerPage: 12,
      docs: [],
      categories: []
    };
  },
  computed: {
    url: function() {
      return this.urlBase + "/suduzyz";
    },
    totalPage: function() {
      return Math.ceil(this.count / this.countPerPage);
    },
    categoryUrl: function() {
      return this.url + "/category";
    },
    countUrl: function() {
      return this.url + "/count";
    },
    imgUrl: function() {
      return this.url + "/img/";
    }
  },
  created: function() {
    this.getCategories();
    this.getCount();
    this.getContent();
  },
  methods: {
    getCategories() {
      $.get(this.categoryUrl, { token: this.token })
        .then(result => {
          if (result.success) {
            this.categories = result.categories;
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    getCount() {
      $.get(`${this.countUrl}?category=${this.category}&keyword=${this.keyword}`, { token: this.token })
        .then(result => {
          if (result.success) {
            this.count = result.count;
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    getContent() {
      $.get(
        `${this.url}?category=${this.category}&keyword=${this.keyword}&page=${this.page}&countPerPage=${this.countPerPage}`,
        { token: this.token }
      )
        .then(result => {
          if (result.success) {
            this.docs = result.docs;
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    handleSearch(filter) {
      this.keyword = filter.keyword||"";
      this.category = filter.category||"";
      this.page = 1;
      this.getCount();
      this.getContent();
      this.hideCategory();
      window.scrollTo(0, 0);
    },
    handleChangePage(p) {
      this.page = p;
      this.getContent();
      window.scrollTo(0, 0);
    },
    hideCategory() {
      $("details")[0].open = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}
h1{
    text-align: center;
    font-family: cursive;
    text-shadow: #aaa 2px 2px 5px
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.suduzyz>details>summary{
  text-align: center
}
</style>
